module.exports = __webpack_public_path__ + "static/media/Maintenance close.2c9fe747.svg";